module.exports = __webpack_public_path__ + "img/jhthd.8ada7084.png";